export default "__VITE_ASSET__BsqE96ON__"